import React, { useEffect, useState } from "react";
import { useAuth } from "../context/Auth";
import { Modal } from "./modal";
import { API, endpoints } from "../api";
import strings, { toastType } from "../utils/strings";
import PubSub from 'pubsub-js'

export const SeasonModal = () => {

    const [seasonModal, setSeasonModal] = useState(false);
    const { hideLoginModal, user, globalLoader, showGlobalLoader, showToast } = useAuth();

    // const [loading, setLoading] = useState(false)
    const [data, setData] = useState({
        season: "",
        year: ""
    });
    // const [forgotPass, setForgotPass] = useState(false);
    // const [resetKey, setResetKey] = useState(0);

    const resetModalState = () => {

    };

    const handleLoginClose = () => {
        setSeasonModal(false);
        resetModalState();
    };

    const handleSignUpClose = () => {
        hideLoginModal();
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const postData = {};
        postData.season = e?.target?.elements?.season?.value;
        postData.season_year = e?.target?.elements?.year?.value;

        console.log("postData -> ", postData)

        // globalLoader,
        //  showGlobalLoader

        showGlobalLoader(false)
        API.post({ route: endpoints.SEASON_ADD, data: postData })
            .then((data) => {
                setSeasonModal(false)
                showToast({
                    text: strings.seasonSuccessMsg,
                    type: toastType.ERROR,
                });
                // updateUser({ ...mainUserData, user: data?.data });
                // setUser(data?.data);
                // setProfileData({ ...profileData, ...data?.data });

                // setTimeout(() => errorClass(), 1000)

                // if (data?.data?.image != "0") setImage(data?.data?.image);
            })
            .finally(() => showGlobalLoader(false));
    }

    const checkSeasonSelection = () => {
        API.get({ route: endpoints.SEASON })
            .then((data) => {
                if (data?.data?.pro_qualified == 'yes' && (!data?.data?.season || !data?.data?.season_year)) {
                    setSeasonModal(true)
                }
            })
            .finally(() => showGlobalLoader(false));

    }

    useEffect(() => {
        checkSeasonSelection()
        var checkSeasonSelectionPubSub = PubSub.subscribe('CHECK_SEASON', () => {
            checkSeasonSelection()
        });
        return () => {
            PubSub.unsubscribe(checkSeasonSelectionPubSub);
        }
    }, [])

    return (
        <Modal show={seasonModal} close={handleLoginClose}>
            <form form id="seasonForm" onSubmit={handleSubmit} >
                <h3 className="font-md">Hey {user?.user?.first_name || user?.user?.name},</h3>
                <h3 className="font-sm mt-3 mb-5">Just a quick step. Let us know when you’re competing next.</h3>
                <div className="font-sm w-100">
                    <div className="flex justify-center">
                        <label className="w150">Season: </label>
                        <select name="season"
                            // className={`w150 no-custom ${!data?.season ? 'red-input' : ''}`}
                            style={{ backgroundPosition: "95% center" }}
                            required className={`font-sm p-0 ps-3 form-control text-grey-900  w150 ${!data?.season ? 'red-input' : ''}`}
                            value={data?.season}
                            onChange={(event) =>
                                setData({
                                    ...data,
                                    season: event.target.value,
                                })
                            }
                        >
                            <option value=""> -- select -- </option>
                            <option>Season A</option>
                            <option>Season B</option>
                        </select>
                    </div>
                    <div className="flex mt-4 justify-center">
                        <label className="w150">Year: </label>
                        <select name="year"
                            style={{ backgroundPosition: "95% center" }}
                            required className={`font-sm p-0 ps-3 form-control text-grey-900  w150 ${!data?.year ? 'red-input' : ''}`}
                            // className={`w150 no-custom ${!data?.year ? 'red-input' : ''}`}
                            value={data?.year}
                            onChange={(event) =>
                                setData({
                                    ...data,
                                    year: event.target.value,
                                })
                            }
                        >
                            <option value=""> -- select -- </option>
                            <option>2025</option>
                            <option>2026</option>
                            <option>2027</option>
                            <option>2028</option>
                            <option>2029</option>
                            <option>2030</option>
                        </select>
                    </div>
                </div>
                <div className="mt-5">
                    <div className="form-group pt-1 flex justify-center">
                        <button className="form-control text-center style2-input text-white fw-600 font-sm bg-primary-gradiant border-0 p-0 w350">
                            Update
                        </button>
                    </div>
                </div>
            </form>

        </Modal>
    );
};
